<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';

import NextButton from 'dashboard/components-next/button/Button.vue';

const shouldStartWithPlusSign = (value = '') => value.startsWith('+');

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      surgeAccountId: '',
      authToken: '',
      webhookSecret: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required, shouldStartWithPlusSign },
    surgeAccountId: { required },
    authToken: { required },
    webhookSecret: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const surgeChannel = await this.$store.dispatch(
          'inboxes/createSurgeChannel',
          {
            surge_channel: {
              name: this.inboxName?.trim(),
              phone_number: this.phoneNumber,
              surge_account_id: this.surgeAccountId,
              auth_token: this.authToken,
              webhook_secret: this.webhookSecret,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: surgeChannel.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.SMS.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.SURGE.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.SURGE.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.SURGE.INBOX_NAME.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.SURGE.PHONE_NUMBER.LABEL') }}
        <input
          v-model="phoneNumber"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.SURGE.PHONE_NUMBER.PLACEHOLDER')"
          @blur="v$.phoneNumber.$touch"
        />
        <span v-if="v$.phoneNumber.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.SURGE.PHONE_NUMBER.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.surgeAccountId.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.SURGE.ACCOUNT_ID.LABEL') }}
        <input
          v-model="surgeAccountId"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.SURGE.ACCOUNT_ID.PLACEHOLDER')"
          @blur="v$.surgeAccountId.$touch"
        />
        <span v-if="v$.surgeAccountId.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.SURGE.ACCOUNT_ID.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.authToken.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.SURGE.AUTH_TOKEN.LABEL') }}
        <input
          v-model="authToken"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.SURGE.AUTH_TOKEN.PLACEHOLDER')"
          @blur="v$.authToken.$touch"
        />
        <span v-if="v$.authToken.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.SURGE.AUTH_TOKEN.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.webhookSecret.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.SURGE.WEBHOOK_SECRET.LABEL') }}
        <input
          v-model="webhookSecret"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.SURGE.WEBHOOK_SECRET.PLACEHOLDER')
          "
          @blur="v$.webhookSecret.$touch"
        />
        <span v-if="v$.webhookSecret.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.SURGE.WEBHOOK_SECRET.ERROR')
        }}</span>
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.SMS.SURGE.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
